import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const SearchBar = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [location, setLocation] = useState('');

  const locationOptions = [
    { value: '', label: 'All Locations' },
    { value: 'bangalore', label: 'Bangalore' },
    { value: 'mumbai', label: 'Mumbai' },
    { value: 'delhi', label: 'Delhi NCR' },
    { value: 'hyderabad', label: 'Hyderabad' },
    { value: 'pune', label: 'Pune' },
    { value: 'chennai', label: 'Chennai' },
    { value: 'kolkata', label: 'Kolkata' },
    { value: 'ahmedabad', label: 'Ahmedabad' }
  ];

  const handleSearch = (e) => {
    e?.preventDefault();
    navigate('/job-listings', { 
      state: { 
        searchQuery, 
        location 
      } 
    });
  };

  return (
    <form onSubmit={handleSearch} className="bg-card border border-border rounded-lg p-4 shadow-card">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-3">
        <div className="md:col-span-5">
          <Input
            type="search"
            placeholder="Job title, keywords, or company"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e?.target?.value)}
            className="w-full"
          />
        </div>

        <div className="md:col-span-4">
          <Select
            options={locationOptions}
            value={location}
            onChange={setLocation}
            placeholder="Select location"
          />
        </div>

        <div className="md:col-span-3">
          <Button 
            type="submit"
            variant="default" 
            fullWidth
            iconName="Search"
            iconPosition="left"
          >
            Search Jobs
          </Button>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mt-3">
        <button
          type="button"
          onClick={() => navigate('/job-listings', { state: { filter: 'remote' } })}
          className="px-3 py-1.5 bg-muted hover:bg-muted/80 text-sm text-foreground rounded-full transition-smooth flex items-center gap-1.5"
        >
          <Icon name="Home" size={14} />
          Remote Jobs
        </button>
        <button
          type="button"
          onClick={() => navigate('/job-listings', { state: { filter: 'fresher' } })}
          className="px-3 py-1.5 bg-muted hover:bg-muted/80 text-sm text-foreground rounded-full transition-smooth flex items-center gap-1.5"
        >
          <Icon name="GraduationCap" size={14} />
          Fresher Jobs
        </button>
        <button
          type="button"
          onClick={() => navigate('/job-listings', { state: { filter: 'urgent' } })}
          className="px-3 py-1.5 bg-muted hover:bg-muted/80 text-sm text-foreground rounded-full transition-smooth flex items-center gap-1.5"
        >
          <Icon name="Zap" size={14} />
          Urgent Hiring
        </button>
        <button
          type="button"
          onClick={() => navigate('/job-listings', { state: { filter: 'wfh' } })}
          className="px-3 py-1.5 bg-muted hover:bg-muted/80 text-sm text-foreground rounded-full transition-smooth flex items-center gap-1.5"
        >
          <Icon name="Laptop" size={14} />
          Work From Home
        </button>
      </div>
    </form>
  );
};

export default SearchBar;